export default {
  data: function(){return{
    availableMetadataOverrideFields: ["campaign_id","campaign_name"],
    //can be overriden for each channel
    metadataOverrideFields: {
      'e':{},
      's':{},
      'd':{}
    }, 
  }},  
  methods: {

  },
  computed: {
    advancedFilters: function() {
      var fields = [];
      if (this.uiConfig.custom_fields || this.uiConfig.metadata_fields) {
        for (let idx in this.uiConfig.custom_fields) {
          // todo add to top level search filters object
          var mdField = this.uiConfig.custom_fields[idx];

          fields.push({
            id: mdField.name,
            name: mdField.name,
            column_name: mdField.column_name,
            requireEmail: mdField.search_method == 'DEPENDENT', 
            displayName: mdField.display_name,
            method: mdField.search_method,
            type: 'custom',
            v2: mdField.v2,
            category: mdField.category
          });
        }
        for (let idx in this.uiConfig.metadata_fields) {
          // todo add to top level search filters object

          var mdField = this.uiConfig.metadata_fields[idx];
          let metadataAttr = null;
          if (mdField.v2){
            //new way of handling metadata attributes
            metadataAttr = "f~" + mdField.sequence_num
          } else {
            //old way
            metadataAttr = mdField.name;
          }
          let channel = 'e' //email by default
          if (mdField.category == 'sms'){
            channel = 's'
          }
          
          //setup metadata override fields
          for (let fieldName of this.availableMetadataOverrideFields){
            if (mdField.name == fieldName) {
              this.metadataOverrideFields[channel][fieldName] = {metadata_attr:metadataAttr};
            }
          }
          
          fields.push({
            id: mdField.name,
            name: mdField.name,
            column_name: mdField.column_name,
            requireEmail: true, 
            displayName: mdField.display_name,
            method: mdField.search_method,
            type: 'metadata',
            category: mdField.category,
            metadata_attr: metadataAttr, 
          });
        }
      }
      return fields;
    },
    campaign: function() {
      let test = this.advancedFilters;
      if (this.selectedRecord.campaign) {
        return this.selectedRecord.campaign
      } else {
        let camp = {}
        let meta = (this.selectedRecord.metadata) ? this.selectedRecord.metadata : {};
        let channel = 'e'; //the default
        //pretty sure this is always set but just being safe
        if (this.selectedRecord.channel){
          channel = this.selectedRecord.channel;
        }
        //derive campaign id from various possible sources
        console.log( "metadataOverrideFields", JSON.stringify(this.metadataOverrideFields[channel]))
        if (this.metadataOverrideFields[channel].campaign_id && meta[this.metadataOverrideFields[channel].campaign_id.metadata_attr]) {
          camp.id = meta[this.metadataOverrideFields[channel].campaign_id.metadata_attr]
        } else if (this.selectedRecord.platform_campaign_id && this.selectedRecord.platform_campaign_id !=-1) {
          camp.id = this.selectedRecord.platform_campaign_id;
        } else if (meta.campaign_id) {
          camp.id = meta.campaign_id;
        } else if (this.selectedRecord.campaign_id){
          camp.id = this.selectedRecord.campaign_id;
        }
        //derive campaign name from various possible sources
        if (this.metadataOverrideFields[channel].campaign_name && meta[this.metadataOverrideFields[channel].campaign_name.metadata_attr]) {
          camp.name = meta[this.metadataOverrideFields[channel].campaign_name.metadata_attr]
        } else if (this.selectedRecord.campaign_name) {
          camp.name = this.selectedRecord.campaign_name;
        } else if (meta.campaign_name){
          camp.name = meta.campaign_name;
        }
        
        //These are Responsys specific
        if (this.selectedRecord.marketing_strategy) {
          camp.marketing_strategy = this.selectedRecord.marketing_strategy;  
        } else if (meta.marketing_strategy || meta.strategy) {
          camp.marketing_strategy = meta.marketing_strategy || meta.strategy;
        }
        if (this.selectedRecord.marketing_program) {
          camp.marketing_program = this.selectedRecord.marketing_program;
        } else if (meta.marketing_program || meta.program) {
          camp.marketing_program = meta.marketing_program || meta.program;
        }
        if (this.selectedRecord.campaign_purpose) {
          camp.purpose = this.selectedRecord.campaign_purpose;
        } else if (meta.channel) {
          camp.purpose = meta.channel;
        }
        
        return camp;
      }
    },
  },
}
